const $ = jQuery.noConflict();

/** @description import Global or some other files only if you need them */
// import Global from './global';

'use strict';
const StickyHeader = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domHeader: $('.js-site-header'),
	$domContent: $('.js-site-content'),
	classSticky: 'sticky-content',
	classStickyHeader: 'sticky-header',
	classScrollingTop: 'scrolling-top',

	/** @description Initialize */
	init: function() {
		StickyHeader.sticky();
	},

	/** @description Make Header sticky on scroll */
	sticky: () => {

		$(window).scroll(function() {
			const scroll = $(window).scrollTop();

			if (scroll >= 1) {
				StickyHeader.$domHeader.addClass(StickyHeader.classStickyHeader);
				StickyHeader.$domContent.addClass(StickyHeader.classSticky);
			} else {
				StickyHeader.$domHeader.removeClass(StickyHeader.classStickyHeader);
				StickyHeader.$domContent.removeClass(StickyHeader.classSticky);
			}
		});
	}
};

export default StickyHeader;
